import { useRef, useState } from "react";
import styles from './Store.module.css';
import _ from "lodash";

import { uploadLogoService } from '../../../services/customerService';
import { canTypeForNumInput } from "../../../utils/numbers";

import { showErrorMessage } from '../../../services/httpService';
import { errorMessage, successMessage } from '../../../utils/message';
import config from "../../../services/config.json";
const { imageIP } = config;

const StoreInfo = ({
   uploadedImage,
   setUploadedImage,
   data,
   setData,
   section,
   states,
   cities,
   postUnits,
   postNodes,
   handelChange,
   nextSection
}) => {
   const [loading, setLoading] = useState(false);
   const [persent, setPersent] = useState(0);
   const fileRef = useRef();
   const allCompleted = (
      data.details.storeName &&
      data.details.storeNameEn &&
      data.details.storeType &&
      data.details.cooperationType &&
      data.details.stateId &&
      data.details.cityId &&
      data.details.postUnitId &&
      data.details.postNodeId &&
      data.details.storePostalCode &&
      data.details.storePhoneNumber &&
      uploadedImage.fileName &&
      data.details.aboutStore
   );

   const getFormat = (fileName) => {
      return fileName.split(".").reverse()[0].toLowerCase();
   };
   const handleUploadImage = async (e) => {
      if (e.target.files) {
         const formData = new FormData();
         formData.append("fileId", data.fileId);
         formData.append("fileType", "logo");
         formData.append("file", e.target.files[0]);

         setLoading(true);
         const fileName = e.target.files[0].name;
         const format = getFormat(fileName);

         if (['png', 'svg', 'jpg', 'jpeg'].includes(format)) {
            const res = await uploadLogoService(formData,
               ProgressEvent => setPersent((ProgressEvent.loaded / ProgressEvent.total) * 100)
            );
            if (res.error) {
               return showErrorMessage(res);
            } else {
               const fileListCopy = _.cloneDeep(data.details.fileList);
               res.data.data.forEach(image => {
                  const found = fileListCopy.findIndex(item => item.fileName === image.fileName);
                  if (found === -1) {
                     fileListCopy.push({ ...image, delete: false });
                  } else {
                     fileListCopy[found].delete = true;
                  }
               });
               setData(prev => ({ ...prev, details: { ...prev.details, fileList: fileListCopy } }));
               setUploadedImage(res.data.data.find(item => item.fileName.slice(9) === fileName));
               successMessage("فایل با موفقیت آپلود شد ");
            }
         }
         else {
            errorMessage("این فرمت پشتیبانی نمیشود");
         }
         setLoading(false);
      }
   };

   return (
      <div
         style={{ minHeight: 'fit-content' }}
         className={section === 1 ? "progresstabs__content active-nav" : "progresstabs__content"}
      >
         {/* <h1 className="progresstabs__content-title">مشخصات فروشگاه</h1> */}

         <div className={`progresstabs__content-receiver ${styles.fields}`}>
            {/* نام فروشگاه  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  نام فروشگاه
                  <input
                     type="text"
                     className="progresstabs__content-receiver-input"
                     name='storeName'
                     value={data.details.storeName}
                     onChange={handelChange}
                  />
               </label>
            </div>
            {/* نام انگلیسی  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  نام انگلیسی
                  <input
                     type="text"
                     className="progresstabs__content-receiver-input"
                     name='storeNameEn'
                     value={data.details.storeNameEn}
                     onChange={handelChange}
                  />
               </label>
            </div>
            {/* نوع فروشگاه  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  نوع فروشگاه
                  <select
                     id="delivery"
                     className="progresstabs__content-receiver-input"
                     name='storeType'
                     value={data.details.storeType}
                     onChange={handelChange}
                  >
                     <option hidden>
                        انتخاب کنید ...
                     </option>
                     <option value='حمل و نقل'>حمل و نقل</option>
                     <option value='فروشگاهی'>فروشگاهی</option>
                  </select>
               </label>
            </div>
            {/* نوع همکاری  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  نوع همکاری
                  <select
                     id="delivery"
                     className="progresstabs__content-receiver-input"
                     name='cooperationType'
                     value={data.details.cooperationType}
                     onChange={handelChange}
                  >
                     <option hidden>
                        انتخاب کنید ...
                     </option>
                     <option value='پنل'>پنل</option>
                     <option value='وب سرویس'>وب سرویس</option>
                  </select>
               </label>
            </div>
            {/* استان  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  استان
                  <select
                     id="delivery"
                     className="progresstabs__content-receiver-input"
                     name='stateId'
                     value={data.details.stateId}
                     onChange={handelChange}
                  >
                     <option hidden>
                        انتخاب کنید ...
                     </option>
                     {states.length !== 0 && states.map((state, index) => (
                        <option key={index} value={state.stateId}>{state.stateTitle}</option>
                     ))}
                  </select>
               </label>
            </div>
            {/* شهر  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  شهر
                  <select
                     disabled={data.details.stateId ? false : true}
                     id="delivery"
                     className="progresstabs__content-receiver-input"
                     name='cityId'
                     value={data.details.cityId}
                     onChange={handelChange}
                  >
                     <option hidden>
                        انتخاب کنید ...
                     </option>
                     {cities.length !== 0 && cities.map((city, index) => (
                        <option key={index} value={city.cityId}>{city.cityTitle}</option>
                     ))}
                  </select>
               </label>
            </div>
            {/* واحد اداره پست  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  واحد اداره پست
                  <select
                     disabled={data.details.stateId ? false : true}
                     id="delivery"
                     className="progresstabs__content-receiver-input"
                     name='postUnitId'
                     value={data.details.postUnitId}
                     onChange={handelChange}
                  >
                     <option hidden>
                        انتخاب کنید ...
                     </option>
                     {postUnits.length !== 0 && postUnits.map((postUnit, index) => (
                        <option key={index} value={postUnit.postUnitId}>{postUnit.postUnitTitle}</option>
                     ))}
                  </select>
               </label>
            </div>
            {/* منطقه پستی  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  منطقه پستی
                  <select
                     disabled={data.details.cityId ? false : true}
                     id="delivery"
                     className="progresstabs__content-receiver-input"
                     name='postNodeId'
                     value={data.details.postNodeId}
                     onChange={handelChange}
                  >
                     <option hidden>
                        انتخاب کنید ...
                     </option>
                     {postNodes.length !== 0 && postNodes.map((postNode, index) => (
                        <option key={index} value={postNode.postNodeId}>{postNode.postNodeTitle}</option>
                     ))}
                  </select>
               </label>
            </div>
            {/* کدپستی فروشگاه  */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  کدپستی فروشگاه
                  <input
                     type="number"
                     className="progresstabs__content-receiver-input"
                     name='storePostalCode'
                     value={data.details.storePostalCode}
                     onChange={handelChange}
                     onKeyDown={canTypeForNumInput}
                  />
               </label>
            </div>
            {/*  تلفن فروشگاه   */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  تلفن فروشگاه
                  <input
                     type="number"
                     name='storePhoneNumber'
                     value={data.details.storePhoneNumber}
                     onChange={handelChange}
                     className="progresstabs__content-receiver-input"
                     onKeyDown={canTypeForNumInput}
                  />
               </label>
            </div>
            {/*  لوگو فروشگاه   */}
            <div className={`progresstabs__content-receiver-content ${styles.field}`}>
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`} style={{ position: 'relative' }}>
                  آپلود لوگو
                  <input
                     style={{ direction: 'ltr', textAlign: 'right', cursor: 'pointer' }}
                     type="text"
                     name="phone"
                     className="progresstabs__content-receiver-input"
                     value={uploadedImage.fileName}
                     readOnly
                     onClick={(e) => {
                        e.preventDefault();
                        fileRef.current.click();
                     }}
                  />
                  <div style={{ top: '4rem' }} className={styles.image__container}>
                     <img
                        style={{ height: '27px', width: 'auto' }}
                        src={uploadedImage?.fileUrl ?
                           `${imageIP}${uploadedImage.fileUrl}` :
                           "/img/upload-3-svgrepo-com.svg"}
                     />
                  </div>
                  <input
                     type="file"
                     ref={fileRef}
                     style={{ display: "none" }}
                     onChange={handleUploadImage}
                  />
               </label>
            </div>
            {/* درباره فروشگاه  */}
            <div
               style={{ flex: '0 0 100%', margin: '0 0 2rem', padding: '4px 0.7rem' }}
               className="progresstabs__content-receiver-content progresstabs__content-receiver-content--address"
            >
               <label className={`progresstabs__content-receiver-label ${styles.progresstabs__content_receiver_label}`}>
                  درباره فروشگاه
                  <textarea
                     style={{ minHeight: '100px' }}
                     className="progresstabs__content-receiver-input"
                     name="aboutStore"
                     value={data.details.aboutStore}
                     onChange={handelChange}
                  />
               </label>
            </div>
         </div>
         <div className="progresstabs__content-buttons">
            <button
               style={{
                  height: '50px',
                  padding: '1rem 2rem',
                  minWidth: '135px',
                  borderRadius: '4px',
                  outline: 'none',
                  border: 'none',
                  color: '#fff',
                  cursor: 'pointer',
                  background: '#21164b',
                  ...(allCompleted ? {} : { opacity: '0.7' })
               }}
               // className={`btn btn--secondary next-btn ${styles.btn}`}
               onClick={allCompleted ? nextSection : undefined}
            >
               تایید و ادامه
            </button>
         </div>
      </div>
   );
};

export default StoreInfo;